import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1d511adc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tenth-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg01",
  src: "https://p6.moimg.net/md/activity/tenth/tenth_bg01.jpg"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg02",
  src: "https://p6.moimg.net/md/activity/tenth/tenth_bg02.jpg"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "bg03",
  src: "https://p6.moimg.net/md/activity/tenth/tenth_bg03.jpg"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "positionR"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "bg04",
  src: "https://p6.moimg.net/md/activity/tenth/tenth_bg04.jpg"
})], -1));
import { mapMutations } from 'vuex';
// import { env } from "md-base-tools/env";
// import domain from '@/service/domain'
const __default__ = {
  data() {
    return {
      shareInfo: {
        active_title: "",
        img: "https://p6.moimg.net/md/activity/tenth/tenth_wx_share_icon.png",
        mina_app_name: "gh_7210ac3f1f08",
        // gh_5638b10d3ccb
        mina_share_img: "https://p6.moimg.net/md/activity/tenth/tenth_mina_share_icon.png",
        mina_share_path: `pages/webviewPages/content/content?url=${domain.wap}/mdactivity/tenth`,
        msg_des: "快来摩点发布众筹，上线即可获首页资源！",
        qq_des: "",
        qq_share_url: `${domain.wap}/mdactivity/tenth`,
        qq_title: "快来摩点发布众筹，上线即可获首页资源！",
        qr_img: "https://p6.moimg.net/md/activity/tenth/tenth_wx_share_icon.png",
        qzone_share_url: `${domain.wap}/mdactivity/tenth`,
        share_url: `${domain.wap}/mdactivity/tenth`,
        sharelink_url: `${domain.wap}/mdactivity/tenth`,
        small_code: "",
        weibo_des: "快来摩点发布众筹，上线即可获首页资源！"`${domain.wap}/mdactivity/tenth` + '（分享自@摩点）',
        weibo_share_url: `${domain.wap}/mdactivity/tenth`,
        weibo_title: "",
        weixin_share_url: `${domain.wap}/mdactivity/tenth`,
        wxTimeline_share_url: `${domain.wap}/mdactivity/tenth`,
        wx_des: "",
        wx_title: "快来摩点发布众筹，上线即可获首页资源！"
      }
    };
  },
  methods: {
    ...mapMutations(['changeShareStatus', 'currentShareUpdate']),
    share() {
      this.currentShareUpdate({
        obj: 'share_info',
        value: this.shareInfo
      });
      if (env.isModianIos() || env.isModianAndroid()) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: 'openShareTool',
          functionParams: JSON.parse(JSON.stringify(this.shareInfo))
        });
      } else {
        this.changeShareStatus({
          obj: 'showShare'
        });
      }
    }
  }
};
import { useStore } from "vuex";
import router from '@/router';
import redirect from '@/service/redirect';
import domain from "@/service/domain";
import { receiveCoins } from "@api/index";
import { mdToast, mdAlert } from '@/utils/tools';
import ShareBox from "@@/common/ShareBox.vue";
import { env } from "md-base-tools/env";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    document.title = '商家感恩盛典';
    const store = useStore();
    const user_id = store.state.user.userId;
    // 查看活动规则
    const goRules = () => {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/mdactivity/tenth_rule`,
        webFun: () => {
          router.push({
            path: `/mdactivity/tenth_rule`
          });
        }
      });
    };
    var loading = false;
    // 领取金币
    const getCoin = async () => {
      if (loading) return;
      loading = true;
      if (!user_id) {
        return redirect.to('login');
      }
      await receiveCoins({
        task_id: '23'
      }).then(res => {
        if (res.status == 0) {
          mdAlert({
            title: '领取成功，可以在商家中心查看',
            actions: ['确定']
          });
        } else {
          mdToast(res.message || '领取失败');
        }
      });
      loading = false;
    };
    // 发起创意
    const goIdea = () => {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `md://publishIdea`,
        webFun: () => {
          if (env.isMobile()) {
            router.push({
              path: `/idea/create`
            });
          } else {
            window.location.href = `https://account.modian.com/initiate/category`;
          }
        }
      });
    };
    // 去往任务中心
    const goMore = () => {
      // eslint-disable-next-line no-undef
      graft.app({
        functionName: "openController",
        functionParams: `${domain.wap}/score/task/index`,
        webFun: () => {
          if (env.isMobile()) {
            router.push({
              path: `/score/task/index`
            });
          } else {
            window.location.href = `https://member.modian.com/operate_manage/task`;
          }
        }
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "positionR"
      }, [_hoisted_2, _createElementVNode("img", {
        class: "rules",
        onClick: goRules,
        src: "https://p6.moimg.net/md/activity/tenth/tenth_rules.png"
      })]), _createElementVNode("div", {
        class: "positionR"
      }, [_hoisted_3, _createElementVNode("img", {
        class: "coin",
        onClick: getCoin,
        src: "https://p6.moimg.net/md/activity/tenth/tenth_btn_coin.png"
      })]), _createElementVNode("div", {
        class: "positionR"
      }, [_hoisted_4, _createElementVNode("img", {
        class: "idea",
        onClick: goIdea,
        src: "https://p6.moimg.net/md/activity/tenth/tenth_btn_idea.png"
      })]), _hoisted_5, _createElementVNode("img", {
        class: "more",
        onClick: goMore,
        src: "https://p6.moimg.net/md/activity/tenth/tenth_btn_more.png"
      }), _createElementVNode("img", {
        class: "share",
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.share && _ctx.share(...args)),
        src: "https://p6.moimg.net/md/activity/tenth/tenth_share.png"
      }), _createVNode(ShareBox)]);
    };
  }
});